import { render, staticRenderFns } from "./RevisingProject.vue?vue&type=template&id=55fe470a&scoped=true"
import script from "./RevisingProject.vue?vue&type=script&lang=js"
export * from "./RevisingProject.vue?vue&type=script&lang=js"
import style0 from "./RevisingProject.vue?vue&type=style&index=0&id=55fe470a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55fe470a",
  null
  
)

export default component.exports